import React from 'react'
import { FastField, useFormikContext } from 'formik'
import { FormHelperText } from '@mui/material'
import { CustomCheckboxWithoutInitialValue } from 'src/form'
import { Section, SubSection } from '../common/Section'
import { IntakeNoteComprehensiveFormType } from './IntakeNoteComprehensiveFormSchema'

export function ConfirmationAndNextStepsForm() {
  const { errors } = useFormikContext<IntakeNoteComprehensiveFormType>()

  return (
    <Section title="Confirmation and Next Steps">
      <SubSection>
        <FastField
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="ELIGIBILITY.ELIGIBLE_FOR_PROGRAM_ENROLLMENT"
          label="Participant is eligible for program enrollment."
        />
        <FastField
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="ELIGIBILITY.PARTICIPANT_DECLINES_ENROLLMENT"
          label="Participant declines program enrollment."
        />
        <FastField
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="ELIGIBILITY.NOT_ELIGIBLE_FOR_PROGRAM_ENROLLMENT"
          label="Participant is not eligible for program enrollment due to clinical appropriateness."
        />
        {errors.ELIGIBILITY && <FormHelperText error>Please select at least one of the options above.</FormHelperText>}
        <FastField
          fullWidth
          component={CustomCheckboxWithoutInitialValue}
          name="REVIEWED_CONFIDENTIALITY_AND_EXPECTATIONS"
          label="Reviewed confidentiality and treatment expectations."
        />
      </SubSection>
    </Section>
  )
}
